import { IJobDescription } from '@/states/job.state';
import { DataConfig } from '@/utils/hooks/useDefaultDataConfig';

export const sortJobDescriptions = (data: IJobDescription[], config: DataConfig) => {
  const dir = config.order === 'asc' ? 1 : -1;

  return [...data].sort((a, b) => {
    const compareString = (x?: string, y?: string) => (x ?? '').localeCompare(y ?? '') * dir;

    switch (config.orderBy) {
      case 'org_chart_node.name':
        return compareString(a.org_chart_node?.name, b.org_chart_node?.name);
      case 'org_key_activity_id':
        return compareString(a.org_key_activity?.name, b.org_key_activity?.name);
      default: {
        const key = config.orderBy as keyof IJobDescription;
        const aVal = a[key] ?? '';
        const bVal = b[key] ?? '';
        if (aVal < bVal) return -1 * dir;
        if (aVal > bVal) return 1 * dir;
        return 0;
      }
    }
  });
};

export const filterJobDescriptions = (
  data: IJobDescription[],
  searchTerm: string,
  selectedRole: string,
  selectedActivity: string,
) => {
  const term = searchTerm.toLowerCase();

  return data.filter(jd => {
    let fileName = '';
    try {
      const files = jd.report_file ? JSON.parse(jd.report_file) : [];
      if (files.length) {
        const file = files[0];
        fileName = file.original_name || file.filename || file.path?.split('/').pop() || '';
      }
    } catch {
      fileName = '';
    }

    const matchText =
      (jd.name ?? '').toLowerCase().includes(term) ||
      (jd.org_chart_node?.name ?? '').toLowerCase().includes(term) ||
      (jd.org_key_activity?.name ?? '').toLowerCase().includes(term) ||
      (jd.frequency ?? '').toLowerCase().includes(term) ||
      (jd.report ?? '').toLowerCase().includes(term) ||
      fileName.toLowerCase().includes(term);

    const matchRole = selectedRole ? String(jd.org_chart_node_id) === selectedRole : true;
    const matchActivity = selectedActivity ? String(jd.org_key_activity_id) === selectedActivity : true;

    return matchText && matchRole && matchActivity;
  });
};

/** Jumlah uraian tugas per jabatan yang `report_file`-nya berisi minimal satu file. */
export const countUploadedByNode = (data: IJobDescription[]): Record<number, number> => {
  const counts: Record<number, number> = {};
  for (const jd of data) {
    if (jd.org_chart_node_id == null || !jd.report_file) continue;
    try {
      const files = JSON.parse(jd.report_file);
      if (Array.isArray(files) && files.length > 0) {
        counts[jd.org_chart_node_id] = (counts[jd.org_chart_node_id] ?? 0) + 1;
      }
    } catch {
      // report_file bukan JSON valid: dianggap belum ada file.
    }
  }
  return counts;
};
